import MagicBrush from './MagicBrush';
import ColourBrush from './ColourBrush';
import common from '../../../common';

const _draw = Symbol('_draw');
const _stopAudio = Symbol('_stopAudio');
const _onColour_Changed = Symbol('_onColour_Changed');

export default class Brush{
	constructor() {
		// Attributes.
		this._drawLayer = null;
		this._magicBrush = null;
		this._colourBrush = null;
		this._paletteItem = null;
		this._curBrush = null;
		this._audio = null;
	}

	init(drawLayer) {
		this._drawLayer = drawLayer;

		// Magic brush.
		this._magicBrush = new MagicBrush();
		this._magicBrush.init(drawLayer);

		// Colour brush.
		this._colourBrush = new ColourBrush();
		this._colourBrush.init(drawLayer);

		// Set initial brush.
		this._curBrush = this._colourBrush;
		this._curBrush.colour = common.gameConfig.palettePanel.pages[0][0];
		this._paletteItem = this._curBrush.colour;

		// Signals.
		common.game.scene.palettePanel.signals.onColourChanged.add(this[_onColour_Changed], this);
	}

	onDrawBegan(point) {
		this._curBrush.onDrawBegan(point);
		// TEST: DYN_OUT:
		this[_draw](point, new PIXI.Point(point.x + 0.1, point.y + 0.1));
	}

	onDrawMoved(from, to) {
		if (this._audio == null)
			this._audio = P3.audio.playSound('sfx_tool_paintbrush_wet_use_loop_00', {'loop': true});
		P3.utils.delay(0.25, ()=>{
			this[_stopAudio]();
		}, null, this);

		this._curBrush.onDrawMoved(from, to);
		this[_draw](from, to);
	}

	onDrawEnded() {
		// Sfx.
		if (this._audio != null)
			this[_stopAudio]();

		// TEST: DYN_OUT:
		common.game.canvas.drawLayer.dynOutlineData = common.game.canvas.drawLayer.dynOutlineContext.getImageData(
			0,
			0,
			common.game.canvas.WIDTH,
			common.game.canvas.HEIGHT);
	}

	[_draw](from, to){
		const dynOutlineContext = common.game.canvas.drawLayer.dynOutlineContext;
		dynOutlineContext.beginPath();
		dynOutlineContext.strokeStyle = 'black';
		dynOutlineContext.lineWidth = this._curBrush.LINE_THICKNESS;
		dynOutlineContext.lineJoin = 'round';
		dynOutlineContext.moveTo(from.x, from.y);
		dynOutlineContext.lineTo(to.x, to.y);
		dynOutlineContext.closePath();
		dynOutlineContext.stroke();
	}

	[_stopAudio](){
		this._audio && this._audio.stop();
		this._audio = null;
	}

	[_onColour_Changed](selection) {
		if (selection.indexOf('#') === 0) {
			this._curBrush = this._colourBrush;
			this._colourBrush.colour = selection;
		}
		else {
			this._curBrush = this._magicBrush;
			this._magicBrush.textureId = selection;
		}

		this._paletteItem = selection;
	}

	get paletteItem(){
		return this._paletteItem;
	}
}